import React, { useState, useEffect } from 'react'
import injectStyles from 'react-jss'
import classNames from 'classnames'

import { Checkbox } from '../../../../Components/Form/Checkbox'

import { PITCH_QUESTION_TYPES } from '../../../../shared/constants'

import DeleteIcon from '../../../../Assets/Images/icons/delete'

import styles from '../PitchQuestionItem/styles'
import StyledIconButton from '../../../Form/StyledIconButton'
import { Input } from '../../../Form/Input/index'

const PitchQuestionOption = ({
  index,
  type,
  onOptionChange,
  onDeleteOption,
  onChangeCorrectAnswer,
  isCorrectAnswer,
  onAddOption,
  value,
  classes,
}) => {
  const {
    item,
    input,
    button,
    buttonDelete,
    checkbox,
    typeIcon: typeIconStyle,
    typeIconCircle,
  } = classes
  const [typeIcon, setTypeIcon] = useState(null)

  useEffect(() => {
    const typeIcon = getTypeIcon({ type })
    setTypeIcon(typeIcon)
  }, [type])

  const getTypeIcon = ({ type }) => {
    if (type === PITCH_QUESTION_TYPES.MULTIPLE_CHOICE) {
      return <div className={classNames(typeIconStyle, typeIconCircle)} />
    }
    if (type === PITCH_QUESTION_TYPES.CHECK_BOX) {
      return <div className={typeIconStyle}>cb</div>
    }
    if (type === PITCH_QUESTION_TYPES.DROPDOWN) {
      return <div className={typeIconStyle}>dd</div>
    }
  }
  const handleKeyPress = event => {
    const keyCode = event.which || event.keyCode
    if (keyCode === 13 || keyCode === 38) {
      onAddOption()
    }
  }
  return (
    <div className={item}>
      {typeIcon}
      <Input
        onChange={e => onOptionChange({ text: e.target.value })}
        onKeyPressCapture={handleKeyPress}
        className={input}
        type="text"
        placeholder="Option"
        value={value}
      />
      <Checkbox
        input={{
          value: isCorrectAnswer,
          onChange: onChangeCorrectAnswer,
        }}
        className={checkbox}
        shouldListenToInputValue
      />
      <StyledIconButton
        className={classNames(button, buttonDelete)}
        onClick={onDeleteOption}
      >
        <DeleteIcon width={8} height={8} fill="white" />
      </StyledIconButton>
    </div>
  )
}

export default injectStyles(styles)(PitchQuestionOption)



// WEBPACK FOOTER //
// ./src/Components/PitchQuestionsForm/blocks/PitchQuestionOption/PitchQuestionOption.js